import { apiContainer } from '@/infrastructure/api/DIContainer'
import { servicesContainer } from '@/infrastructure/services/DIContainer'
import { Container } from 'inversify'

export function infrastructureContainer(container: Container): void {
  apiContainer(container)
  servicesContainer(container)
}
